<template>
  <div>
    <div class="heads">
      <span class="fw600">数据权限</span>
      （设置改角色的用户可以操作的数据的范围）
    </div>
    <el-radio v-model="radio" :label="3">
      <div class="left">部门账号</div>
      <div class="right">自己部门的数据</div>
    </el-radio>
    <el-radio v-model="radio" :label="2">
      <div class="left">公司总账号</div>
      <div class="right">全公司及所有所属部门的数据</div>
    </el-radio>
    <!-- <el-radio v-model="radio" :label="1">
      <div class="left">超级管理员权限</div>
      <div class="right">能操作所有公司的数据</div>
    </el-radio> -->
    <div class="submit-btn">
      <el-button type="primary" @click="update()" :loading="btnLoading"
        >提交</el-button
      >
    </div>
  </div>
</template>
<script>
import { upLevel } from '@/api/role'
export default {
  props: ['data'],
  data () {
    return {
      radio: 1,
      btnLoading: false
    }
  },
  watch: {
    data () {
      this.radio = parseInt(this.data.level)
    }
  },
  methods: {
    update () {
      let params = {
        roleId: this.data.id,
        level: this.radio
      }
      this.btnLoading = true
      upLevel(params).then(da => {
        if (da.code === 0) {
          this.$message.success('修改成功')
          this.$router.go(-1)
        }
      }).finally(() => {
        this.btnLoading = false
      })
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.el-radio {
  display: flex;
  margin-bottom: 10px;
}
/deep/ .el-radio__label {
  display: flex;
}
.heads {
  margin-bottom: 20px;
}
.fw600 {
  font-weight: 600;
}
.left {
  width: 200px;
}
.right {
  color: #999;
}
.submit-btn {
  text-align: center;
}
</style>